<template>
  <div class="home-page">
    <!-- 把轮播图和导航放在首页组件里 -->
    <AppCarousel :carouselImages="homeCarouselImages"/>
    <div>
      <PageNavigation :subjectNavList="navData" @navigate="handleNavigate" />
    </div>

<div class="container">
      <div 
        v-for="(item, index) in filteredList" 
        :key="index" 
        class="title-item" 
        @click="navigateToPage(item)"
      >
        {{ item.title }}
      </div>
    </div>



  </div>
</template>

<script setup>

import AppCarousel from '../components/AppCarousel.vue'
// Home页面的轮播图数据
const homeCarouselImages = [
{ videoPath: '/to-singlevideo',
  url: './pic/carouselPic/zhiyuan1.jpg', 
  alt: '16:9轮播图1',
   title:'免费高考志愿填报',
   videosrc:'https://wk.bqpd.top/b09feb4avodcq1379112376/d993c6555145403700936560600/OMQ0hxW1o2oA.mp4',
   },
   { videoPath: '/to-singlevideo',
     url: './pic/carouselPic/zhiyuan2.png', 
     alt: '16:9轮播图1',
      title:'nihao',
      videosrc:'https://wk.bqpd.top/b09feb4avodcq1379112376/d993c6555145403700936560600/OMQ0hxW1o2oA.mp4',
      }
]



import { ref } from 'vue';//导入响应式数据
//给数组填充数据
const filteredList = ref([
{
title:'免费高考志愿填报指南',
videosrc: 'https://wk.bqpd.top/b09feb4avodcq1379112376/4712bdf85145403701530952382/pZK2vSOKDUcA.mp4'
},
{title:'升学规划咨询/职业规划咨询176 3035 6892'},

])

import { useRouter} from 'vue-router'//引入导航行路由。
const router = useRouter()//调用useRouter()函数。

// 导航函数
const navigateToPage = (item) => {
  
  // 方式2: 使用Vue Router（如果在H5环境）
  router.push({
            path: '/to-singlevideo',
            query: { 
                     
                    title: item.title,
                 videosrc: item.videosrc
                    } //
          })
  
}






</script>
<style scoped>
.container {
  padding: 20rpx;
}

.title-item {
  width: 100%;           /* 宽度充满父容器 */
    box-sizing: border-box; /* 防止padding撑大宽度 */
    padding: 15px;         /* 原30rpx转换为15px（rpx通常1rpx≈0.5px） */
    margin-bottom: 10px;   /* 原20rpx转换为10px */
    background-color: #f5f5f5;
    border-radius: 4px;    /* 原8rpx转换为4px */
    font-size: 16px;       /* 原32rpx转换为16px */
    color: #333;
    border: none;          /* 移除默认边框（如果用于按钮） */
    text-align: left;      /* 文字左对齐 */
    cursor: pointer;       /* 鼠标悬停显示手型 */
    transition: background-color 0.2s ease; /* 平滑过渡效果 */
}

.title-item:active {
  background-color: #e5e5e5; /* 点击反馈效果 */
}


/* 电脑端专属：控制轮播图大小（屏幕≥1024px时生效） */
@media (min-width: 1024px) {
  /* 限制中间显示区宽度为手机竖屏常见宽度（如375px，可修改） */
  .container {
    max-width: 500px !important; /* 中间显示区宽度（手机常见宽度） */
    margin: 20px auto !important; /* 左右自动留白，居中显示 */
  }
}
</style>